import script from "./ComparisonTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ComparisonTable.vue?vue&type=script&setup=true&lang=js"

import "./ComparisonTable.vue?vue&type=style&index=0&id=e020bffc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e020bffc"]])

export default __exports__